import React from 'react'
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useTheme
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'

interface CollapsibleInputCardProps {
  title: string
  isValidated: boolean
  isValidating?: boolean
  validationFailed?: boolean
  onEdit: () => void
  expandedContent: React.ReactNode
  collapsedSummary?: string
  collapsedChips?: React.ReactNode
  isMobile?: boolean
}

export const CollapsibleInputCard: React.FC<CollapsibleInputCardProps> = ({
  title,
  isValidated,
  validationFailed = false,
  onEdit,
  expandedContent,
  collapsedSummary,
  collapsedChips
}) => {
  const theme = useTheme()

  if (!isValidated) {
    return (
      <Card
        variant="outlined"
        style={{
          border: validationFailed
            ? `2px solid ${theme.palette.error.main}`
            : `1px solid ${theme.palette.divider}`
        }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom color="primary">
            {title}
          </Typography>
          {expandedContent}
        </CardContent>
      </Card>
    )
  }

  return (
    <Card
      variant="outlined"
      style={{
        border: `2px solid ${theme.palette.success.main}`,
        backgroundColor: theme.palette.success.light + '10'
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            {collapsedSummary && (
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                {collapsedSummary}
              </Typography>
            )}
            {collapsedChips && (
              <Box mt={1}>
                {collapsedChips}
              </Box>
            )}
          </Box>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={onEdit}
          >
            <EditIcon />
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}